// Human copy for server notification rows. The server stores facts
// (kind + payload); wording lives here so every surface (menu row, toast)
// says the same thing.

function formatLabel(mode, format) {
  if (mode === 'match') return format === 'peasant' ? 'Peasant' : 'Constructed';
  if (mode === 'sandbox') return 'Sandbox';
  if (mode === 'draft') return 'Draft';
  if (mode === 'sealed') return 'Sealed';
  return mode || 'match';
}

function mailTitle(p) {
  const subject = p.subject ? `: ${p.subject}` : '';
  switch (p.mailType) {
    case 'auction': return `Auction House${subject}`;
    case 'news': return `News${subject}`;
    case 'season-voucher': return `Season reward${subject}`;
    default: return `${p.senderName || 'Someone'} sent you mail${subject}`;
  }
}

/**
 * @param {object} n notification row from the server
 * @returns {{ title: string, body: string|null, actor: string|null }}
 */
export function describeNotification(n) {
  const p = n?.payload || {};
  const count = Number(p.count) || 1;
  const actor = p.actorName || 'Someone';
  const many = count > 1;
  switch (n?.kind) {
    case 'deck.comment':
      return {
        title: `${actor} commented on ${p.isOwner === false ? 'a deck you follow' : 'your deck'}${p.deckName ? ` ${p.deckName}` : ''}`,
        body: p.excerpt || null,
        actor,
      };
    case 'deck.like':
      return {
        title: many
          ? `${count} players liked your deck${p.deckName ? ` ${p.deckName}` : ''}`
          : `${actor} liked your deck${p.deckName ? ` ${p.deckName}` : ''}`,
        body: null,
        actor,
      };
    case 'deck.comment.like':
      return {
        title: many
          ? `${count} players liked your comment on ${p.deckName || 'a deck'}`
          : `${actor} liked your comment on ${p.deckName || 'a deck'}`,
        body: p.excerpt || null,
        actor,
      };
    case 'replay.comment':
      return {
        title: `${actor} commented on ${p.matchName ? `the replay of ${p.matchName}` : 'a replay'}`,
        body: p.excerpt || null,
        actor,
      };
    case 'replay.like':
      return { title: `${actor} liked your replay comment`, body: null, actor };
    case 'chat.reply':
      return { title: `${actor} replied to you in the Tavern`, body: p.excerpt || null, actor };
    case 'chat.mention':
      return { title: `${actor} mentioned you in the Tavern`, body: p.excerpt || null, actor };
    case 'chat.like':
      return {
        title: many
          ? `${count} players reacted to your Tavern message`
          : p.emoji ? `${actor} reacted ${p.emoji} to your Tavern message` : `${actor} liked your Tavern message`,
        body: p.excerpt || null,
        actor,
      };
    case 'chat.message':
      return {
        title: many ? `${count} new messages from ${actor}` : `New message from ${actor}`,
        body: p.excerpt || (p.messageType === 'tavern' ? 'Forwarded a message from the Tavern' : p.messageType && p.messageType !== 'text' ? `Sent a ${p.messageType}` : null),
        actor,
      };
    case 'mail.received':
      return {
        title: mailTitle(p),
        body: p.hasAttachments ? 'Has attachments to claim' : null,
        actor: p.senderName || null,
      };
    case 'friend.request':
      return { title: `${actor} wants to be your friend`, body: null, actor };
    case 'friend.accepted':
      return { title: `${actor} accepted your friend request`, body: null, actor };
    case 'match.closed':
      return {
        title: `Your ${p.visibility || ''} ${formatLabel(p.mode, p.format)} lobby closed`.replace('  ', ' '),
        body: 'Nobody joined in time, so the seat was freed.',
        actor: null,
      };
    case 'match.expired':
      return {
        title: `Your paused ${formatLabel(p.mode, p.format)} match expired`,
        body: 'It sat untouched for 30 days.',
        actor: null,
      };
    case 'invite.expired':
      return {
        title: `${actor}'s ${p.inviteKind === 'resume' ? 'resume request' : 'invite'} to a ${formatLabel(p.mode, p.format)} match lapsed`,
        body: null,
        actor,
      };
    default:
      return { title: n?.kind || 'Notification', body: null, actor: null };
  }
}

// Whether a click on the row leads somewhere. Informational rows
// (lobby closed) have nothing to open.
export function notificationHasTarget(n) {
  switch (n?.kind) {
    case 'match.closed':
    case 'match.expired':
    case 'invite.expired':
      return false;
    default:
      return true;
  }
}
